interface ItemRowSkeletonProps {
  message?: string;
}

const ItemRowSkeleton = ({ message }: ItemRowSkeletonProps) => {
  return (
    <div
      style={{
        height: '60px',
        padding: '5px 0',
        margin: '0 10px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Image placeholder */}
      <div
        className="shimmer"
        style={{
          width: '60px',
          height: '60px',
          flexShrink: 0,
          borderRadius: '4px',
        }}
      />
      {/* Text content */}
      <div
        style={{
          flex: 1,
          padding: '10px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '8px',
        }}
      >
        {/* Title placeholder or message */}
        {message ? (
          <span style={{ color: 'var(--secondary)', fontSize: '0.9rem' }}>
            {message}
          </span>
        ) : (
          <div
            className="shimmer"
            style={{ height: '16px', width: '70%', borderRadius: '4px' }}
          />
        )}
        {/* Subtitle placeholder */}
        <div
          className="shimmer"
          style={{ height: '12px', width: '40%', borderRadius: '4px' }}
        />
      </div>
    </div>
  );
};

export default ItemRowSkeleton;
